import { call, put, takeEvery, delay } from 'redux-saga/effects';

import { captureException } from '../../../client/sentry';
import { pushEvent } from '../../../client/data-layer';
import { logoutComplete, logoutFailed } from '../actions';

import { logout, logoutFromClassic } from '../requests';
import { getCurrentRef } from '../helpers';
import { promptToast } from '../../../components/toast-container/actions';

export function* logoutSaga({ message }) {
  try {
    const { success, error, classicLogoutUrl } = yield call(logout);

    if (success) {
      // Reset Google Tag Manager user variables on logout
      yield call(pushEvent, 'userReceive', {
        me: undefined,
      });

      yield put(logoutComplete());

      const { replace } = window.__history;

      if (message) {
        yield put(promptToast('success', message));
        yield delay(500);
      }

      yield call(replace, getCurrentRef().path);

      if (classicLogoutUrl) {
        yield call(logoutFromClassic, classicLogoutUrl);
      }
    } else {
      // logout failed
      yield put(logoutFailed(error));
    }
  } catch (e) {
    yield call(captureException, e);
    yield put(logoutFailed(e.message));
  }
}

function* mySaga() {
  yield takeEvery('LOGOUT_REQUEST', logoutSaga);
}

export default mySaga;
